module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.projectID) ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("inputs.no_project_loaded")) + ".")])])]) : (!_vm.hasData) ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("inputs.data_not_loaded")))])])]) : _c('div', [(_vm.sheetNames) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('help', {
    attrs: {
      "reflink": "inputs",
      "label": _vm.$t("inputs.Edit input data")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "controls-box"
  }, [_c('b', [_vm._v("Databook:  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeDataset),
      expression: "activeDataset"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeDataset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getSheetData()
      }]
    }
  }, _vm._l((_vm.datasetOptions), function(dataset) {
    return _c('option', [_vm._v("\n                " + _vm._s(dataset) + "\n              ")])
  }), 0), _vm._v(" \n            "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t('Rename')
    },
    on: {
      "click": function($event) {
        return _vm.renameDatasetModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-pencil"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t('Copy')
    },
    on: {
      "click": function($event) {
        return _vm.copyDataset()
      }
    }
  }, [_c('i', {
    staticClass: "ti-files"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t('Delete')
    },
    on: {
      "click": function($event) {
        return _vm.deleteDataset()
      }
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t('Download')
    },
    on: {
      "click": function($event) {
        return _vm.downloadDatabook()
      }
    }
  }, [_c('i', {
    staticClass: "ti-download"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t('Upload')
    },
    on: {
      "click": function($event) {
        return _vm.uploadDatabook()
      }
    }
  }, [_c('i', {
    staticClass: "ti-upload"
  })]), _vm._v(" "), _vm._v("  \n            ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn __green",
    attrs: {
      "data-tooltip": _vm.$t('inputs.save_tooltip')
    },
    on: {
      "click": function($event) {
        return _vm.saveSheetData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("inputs.save_changes")))]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    attrs: {
      "data-tooltip": _vm.$t('inputs.revert_tooltip')
    },
    on: {
      "click": function($event) {
        return _vm.getSheetData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("inputs.revert")))])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.sheetNames), function(ref) {
    var key = ref[0];
    var label = ref[1];

    return _c('div', {
      staticStyle: {
        "display": "inline-block",
        "padding-right": "10px"
      }
    }, [(key === _vm.activeSheet) ? _c('div', [_c('button', {
      staticClass: "btn sheetbtn",
      attrs: {
        "data-tooltip": _vm.$t("inputs.Current sheet")
      },
      on: {
        "click": function($event) {
          _vm.activeSheet = key
        }
      }
    }, [_vm._v(_vm._s(label))])]) : _c('div', [_c('button', {
      staticClass: "btn sheetbtn deselected",
      attrs: {
        "data-tooltip": _vm.$t("inputs.Switch to this sheet")
      },
      on: {
        "click": function($event) {
          _vm.activeSheet = key
        }
      }
    }, [_vm._v(_vm._s(label))])])])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "icantbelieveitsnotexcel"
  }, [(!_vm.customSheets.includes(_vm.activeSheet)) ? _c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.sheetTables[_vm.activeSheet]), function(rowData) {
    return _c('tr', _vm._l((rowData), function(cellDict) {
      return _c('td', [(cellDict.format === 'head') ? _c('div', {
        staticClass: "cell c_head"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_vm._v(_vm._s(cellDict.value))])]) : _vm._e(), _vm._v(" "), (cellDict.format === 'name') ? _c('div', {
        staticClass: "cell c_name"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_vm._v(_vm._s(cellDict.value))])]) : _vm._e(), _vm._v(" "), (cellDict.format === 'blnk') ? _c('div', {
        staticClass: "cell c_blnk"
      }, [_c('div', {
        staticClass: "cellpad"
      })]) : _vm._e(), _vm._v(" "), (cellDict.format === 'tick') ? _c('div', {
        staticClass: "cell c_tick"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cellDict.value),
          expression: "cellDict.value"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(cellDict.value) ? _vm._i(cellDict.value, null) > -1 : (cellDict.value)
        },
        on: {
          "change": function($event) {
            var $$a = cellDict.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(cellDict, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(cellDict, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(cellDict, "value", $$c)
            }
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (cellDict.format === 'edit') ? _c('div', {
        staticClass: "cell c_edit"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cellDict.value),
          expression: "cellDict.value"
        }],
        staticClass: "txbox",
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (cellDict.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(cellDict, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (cellDict.format === 'bdgt') ? _c('div', {
        staticClass: "cell c_edit"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cellDict.value),
          expression: "cellDict.value"
        }],
        staticClass: "txbox",
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (cellDict.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(cellDict, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (cellDict.format === 'calc') ? _c('div', {
        staticClass: "cell c_calc"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cellDict.value),
          expression: "cellDict.value"
        }],
        staticClass: "txbox",
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "type": "text",
          "disabled": true
        },
        domProps: {
          "value": (cellDict.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(cellDict, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (cellDict.format === 'drop') ? _c('div', {
        staticClass: "cell c_drop"
      }, [_c('div', {
        staticClass: "cellpad"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cellDict.value),
          expression: "cellDict.value"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(cellDict, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.costFuncOptions), function(costFunc) {
        return _c('option', [_vm._v(_vm._s(costFunc))])
      }), 0)])]) : _vm._e()])
    }), 0)
  }), 0) : (_vm.activeSheet == 'program_dependencies') ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "c_head"
  }, [_vm._v(_vm._s(_vm.$t("inputs.Program")))]), _vm._v(" "), _c('td', {
    staticClass: "c_head"
  }, [_vm._v(_vm._s(_vm.$t("inputs.Exclusion dependency")))]), _vm._v(" "), _c('td', {
    staticClass: "c_head"
  }, [_vm._v(_vm._s(_vm.$t("inputs.Threshold dependency")))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.sheetTables['program_dependencies']), function(entry, index) {
    return _c('tr', [_c('td', {
      staticClass: "c_drop"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entry.program),
        expression: "entry.program"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(entry, "program", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.programOptions), function(program) {
      return _c('option', [_vm._v(_vm._s(program))])
    }), 0)]), _vm._v(" "), _c('td', {
      staticClass: "c_drop"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entry.exclusion),
        expression: "entry.exclusion"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(entry, "exclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((_vm.programOptions), function(program) {
      return _c('option', [_vm._v(_vm._s(program))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticClass: "c_drop"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entry.threshold),
        expression: "entry.threshold"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(entry, "threshold", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((_vm.programOptions), function(program) {
      return _c('option', [_vm._v(_vm._s(program))])
    })], 2)]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-icon __red",
      on: {
        "click": function($event) {
          return _vm.sheetTables['program_dependencies'].splice(index, 1)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })])])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    on: {
      "click": function($event) {
        return _vm.sheetTables['program_dependencies'].push({
          'program': _vm.programOptions[0],
          'exclusion': undefined,
          'threshold': undefined
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("inputs.Add dependency")))])]) : _vm._e()]), _vm._v(" "), _c('br')], 2)]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "rename-dataset",
      "height": "auto",
      "classes": ['v--modal', 'vue-dialog'],
      "width": _vm.width,
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": _vm.clickToClose
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n          Rename databook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_vm._v("\n          New name:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeDataset),
      expression: "activeDataset"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeDataset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeDataset = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.renameDataset()
      }
    }
  }, [_vm._v("\n            Rename\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('rename-dataset')
      }
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676acd17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/InputsPage.vue
// module id = 384
// module chunks = 1